import api from '@/api/api.coffee'
export default
  # Restaurant
  restaurant: (state, getters) ->
    return '' unless state?.restaurant
    state.restaurant
  ip: (state, getters) ->
    return '' unless state?.ip
    state.ip
  subdomain: (state, getters) ->
    subdomain = api.getIncomingDomain(window.location.hostname, true)  
    if subdomain == 'localhost'
      return 'dev'
    subdomain
  tableNo: (state, getters) ->
    return '' unless state?.tableNo
    state.tableNo
  sourceLanguage: (state, getters) ->
    defaultLanguage = 'en'  
    sourceLanguage = state.restaurant?.location?.sourceLanguage
    return sourceLanguage if sourceLanguage and sourceLanguage.length > 0
    defaultLanguage
  destinationLanguage: (state, getters) ->
    defaultLanguage = 'en'
    userLangs = navigator.languages or [navigator.language]
    primary = userLangs
    primary = primary.map((l) -> l.toLowerCase().split('-')[0])
    primary = primary.filter((l) -> /^[a-z]{2}$/.test(l))[0]
    primary = primary.toLowerCase()    
    destinationLanguages = state.restaurant?.location?.destinationLanguages
    return defaultLanguage unless Array.isArray(destinationLanguages) and destinationLanguages.length > 0
    destinationLanguages = destinationLanguages.map((l) -> l.toLowerCase().split('-')[0])
    destinationLanguages = destinationLanguages.filter((l) -> /^[a-z]{2}$/.test(l))    
    return primary if primary in destinationLanguages    
    defaultLanguage
  restaurantIconBanner: (state, getters) ->
    false
  restaurantIconHeader: (state, getters) ->
    true
  restaurantIconUrl: (state, getters) ->    
    return '' unless state?.restaurant.stylesheet.iconUrl
    if Number(state.restaurant.stylesheet.iconUrl.indexOf 'http') == -1
      state.restaurant.stylesheet.iconUrl = 'https://api.onlineordersnow.com'+state.restaurant.stylesheet.iconUrl
    state.restaurant.stylesheet.iconUrl
  restaurantHeaderUrl: (state, getters) ->    
    return '' unless state?.restaurant?.stylesheet?.headerUrl
    if Number(state.restaurant.stylesheet.headerUrl.indexOf 'http') == -1
      state.restaurant.stylesheet.headerUrl = 'https://api.onlineordersnow.com'+state.restaurant.stylesheet.headerUrl
    state.restaurant.stylesheet.headerUrl
  restaurantBrand: (state, getters) ->    
    return '' unless state?.restaurant?.brand
    state.restaurant.brand
  restaurantId: (state, getters) ->
    return '' unless state?.restaurant?.uniqueId
    state.restaurant.uniqueId
  customer: (state, getters) ->
    return '' unless state?.user
    state.user
  customerId: (state, getters) ->
    return '' unless state?.user?.customerId
    state.user.customerId
  restaurantBrandHeader: ->
    true
  restaurantBrandMenuDrawer: ->
    false
  #User
  user: (state, getters) ->
    return {} unless state?.user
    state.user
  showEdit: (state, getters) ->
    return '' unless state?.showEdit
    state.showEdit
  phone: (state, getters) ->
    return '' unless state?.mobile
    state.mobile
  # Toggle
  toggleOpen:(state, getters) ->
    return 'Open Menu' unless state?.toggleOpen
    state.toggleOpen
  toggleClose:(state, getters) ->
    return 'Close Menu' unless state?.toggleClose
    state.toggleClose
  # Order
  orderHeader: (state, getters) ->
    return 'Your Order' unless state?.orderHeader
    state.orderHeader
  orderMessage: (state, getters) ->
    return 'Please add some items to your order.' unless state?.orderMessage
    state.orderMessage
  orderingBranding: (state, getters) ->
    return { enabled: false } unless state?.orderingBranding?.enabled
    if getters.subdomain  
      subdomain = getters.subdomain
      if (/^valsrapidservkiosk$/ui).test(subdomain) or (/^demovalskiosk$/ui).test(subdomain)
        return { enabled: true, url: null, brand: "Val's" }
    state.orderingBranding
  discount: (state, getters) ->
    return 'Discount' unless state?.discount
    state.discount
  subtotal: (state, getters) ->
    return 'Subtotal' unless state?.subtotal
    state.subtotal

  order: (state, getters) ->
    return '' unless state?.order
    state.order
  orderId: (state, getters) ->
    orderId = state?.order?.orderId
    return '' if !orderId
    orderId
  orderOONKey: (state, getters) ->
    orderOONKey = state?.order?.oonKey
    return '' if !orderOONKey
    orderOONKey    
  orderDetails: (state, getters) ->
    return '' unless state?.order
    state.order
  orderItemSum: (state, getters) ->    
    return 0 unless state?.order?.orderItemSum
    state.order.orderItemSum
  orderItemTotal: (state, getters) ->
    return 0 unless state?.order?.orderItemTotal
    state.order.orderItemTotal
  orderSubTotal: (state, getters) ->    
    return 0 unless state?.order?.orderSubTotal
    state.order.orderSubTotal
  orderTotal: (state, getters) ->
    return 0 unless state?.order?.orderTotal
    state.order.orderTotal
  orderPaid: (state, getters) ->
    return 0 unless state?.order?.orderPaid
    state.order.orderPaid
  orderDue: (state, getters) ->
    return 0 unless state?.order?.orderDue
    state.order.orderDue
  editFlag: (state, getters) ->
    return '' unless state?.order
    state.order.itemDetails.editFlag
  orderTip: (state, getters) ->    
    return 0 unless state?.order?.tip
    state.order.tip
  orderComment: (state, getters) ->    
    return '' unless state?.order?.comment
    state.order.comment
  customerEmail: (state, getters) ->
    return 0 unless state?.order?.email
    state.order.email
  orderDiscount: (state, getters) ->
    return 0 unless state?.order?.orderDiscount
    state.order.orderDiscount
  deliveryFee: (state, getters) ->
    return 0 unless state?.order?.deliveryFee
    state.order.deliveryFee
  orderTaxAmount: (state, getters) ->
    return 0 unless state?.order?.orderTaxAmount
    state.order.orderTaxAmount
  orderFeeAmount: (state, getters) ->
    return 0 unless state?.order?.orderFeeAmount
    state.order.orderFeeAmount
  orderTaxAndFee: (state, getters) ->
    return 0 unless state?.order
    state.order.orderTaxAndFee
  orderTaxList: (state, getters) ->
    return 0 unless state?.order?.orderTaxes
    state.order.orderTaxes
  orderFeeList: (state, getters) ->
    return 0 unless state?.order?.orderFees
    state.order.orderFees
  orderItemsLength: (state, getters) ->
    return 0 unless state?.order?.items
    state.order.items.length
  orderItemDetailsLength: (state, getters) ->
    return 0 unless state?.order?.itemDetails
    state.order.itemDetails.length
  orderItems: (state, getters) ->
    return '' unless state?.order?.items
    state.order.items
  orderItemDetails: (state, getters) ->
    return [] unless state?.order?.itemDetails
    state.order.itemDetails
  orderEditDetails: (state, getters) ->
    return [] unless state?.order
    state.order.editDetails
  orderCheckoutFlag: (state, getters) ->
    return [] unless state?.order
    state.order.checkoutFlag
  orderLowInventory: (state, getters) ->
    return [] unless state?.order
    state.order.lowInventory
  orderUpdated: (state, getters) ->
    return false unless state?.order?.updated
    state.order.updated
  orderMenu: (state, getters) ->
    return [] unless state?.orderMenu
    state.orderMenu
  orderMenuDetails: (state, getters) ->
    return [] unless state?.orderMenuDetails
    state.orderMenuDetails
  orderMenuDetailsLoaded: (state, getters) ->
    return false unless state?.orderMenuDetails
    state.orderMenuDetails.length > 0

  # coupons
  coupons: (state, getters) ->
    return [] unless state?.coupons
    state.coupons
  couponItemIds: (state, getters) ->    
    return {} unless state?.coupons?.itemIds
    state.coupons.itemIds
  mywayIds: (state, getters) ->    
    return {} unless state?.myway?.itemIds
    state.myway.itemIds
  # Header
  headerOrderTitle: (state, getters) ->
    return "Cart" unless state?.headerOrderTitle
    state.headerOrderTitle
  headerOrderIcon: (state, getters) ->
    return "fa-shopping-cart"
  headerCheckoutTitle: (state, getters) ->
    return "Checkout" unless state?.headerCheckoutTitle
    state.headerCheckoutTitle
  headerCheckoutIcon: (state, getters) ->
    return "fa-check-circle"
  headerCouponTitle: (state, getters) ->
    return "Coupons" unless state?.headerCouponTitle
    state.headerCouponTitle
  headerFaqTitle: (state, getters) ->
    return "FAQs" unless state?.headerFaqTitle
    state.headerFaqTitle
  headerCouponIcon: (state, getters) ->
    return "fa-tags"
  headerFeaturesTitle: (state, getters) ->
    return "Popular" unless state?.headerFeaturesTitle
    state.headerFeaturesTitle
  forgetLabel: (state, getters) ->
    return "Don't Forget" unless state?.forgetLabel
    state.forgetLabel
  headerFeaturesIcon: (state, getters) ->
    return "fa-award"
  headerMywayTitle: (state, getters) ->
    return "My Way" unless state?.headerMywayTitle
    state.headerMywayTitle
  headerMywayIcon: (state, getters) ->
    return "fa-award"
  buttonCheckoutLabel: (state, getters) ->
    return "Checkout" unless state?.buttonCheckoutLabel
    state.buttonCheckoutLabel
  buttonSendOrderLabel: (state, getters) ->
    return "Order Now" unless state?.buttonSendOrderLabel
    state.buttonSendOrderLabel
  buttonMenuLabel: (state, getters) ->
    return "Menu" unless state?.buttonMenuLabel
    state.buttonMenuLabel
  okLabel: (state, getters) ->
    return "Ok" unless state?.okLabel
    state.okLabel

  #Menu Header / footer
  menuFlag:  (state, getters) ->
    return false unless getters?.location?.optionalText?.includeMenuText
    getters.location.optionalText.includeMenuText
  headerText: (state, getters) ->
    return '' unless getters?.location?.optionalText?.menuText
    getters.location.optionalText.menuText
  footerText: (state, getters) ->
    return '' unless getters?.location?.optionalText?.menuFooterText
    getters.location.optionalText.menuFooterText
  categoryPanels: (state, getters) ->    
    return {} unless state?.panels?.category
    state.panels.category
  pizzaPanels: (state, getters) ->    
    return {} unless state?.panels?.pizza
    state.panels.pizza
  typePanels: (state, getters) ->    
    return {} unless state?.panels?.pizzaType
    state.panels.pizzaType
  menuItemGroupPanels: (state, getters) ->    
    return {} unless state?.panels?.menuitemgroup
    state.panels.menuitemgroup
  jumpCategoryId: (state, getters) ->
    return '' unless state?.jumpCategoryId
    state.jumpCategoryId
  # Drawers
  menuDrawer: (state, getters) ->    
    return false unless state?.drawers?.menu
    state.drawers.menu
  menuDrawerLinks: (state, getters) ->
    return false unless state?.restaurant
    out = []
    if state?.restaurant?.stylesheet?.mainWebsite
      out.push { "title": "Website", "href": state.restaurant.stylesheet.mainWebsite, "target": "_blank", "icon": "fa-external-link", "ariaLabel": "Links to Restaurant Website - Opens in new tab" }
    if state?.restaurant?.stylesheet?.facebook
      out.push { "title": "Facebook", "href": state.restaurant.stylesheet.facebook, "target": "_blank", "icon": "fa-brands fa-facebook-f", "ariaLabel": "Links to Restaurant Facebook - Opens in new tab" }
    if state?.restaurant?.stylesheet?.instagram
      out.push { "title": "Instagram", "href": state.restaurant.stylesheet.instagram, "target": "_blank", "icon": "fa-brands fa-instagram", "ariaLabel": "Links to Restaurant Instagram - Opens in new tab" }
    if state?.restaurant?.stylesheet?.tiktok
      out.push { "title": "TikTok", "href": state.restaurant.stylesheet.tiktok, "target": "_blank", "icon": "fa-brands fa-tiktok", "ariaLabel": "Links to Restaurant Tiktok - Opens in new tab" }
    if state?.restaurant?.stylesheet?.twitter
      out.push { "title": "X (Twitter)", "href": state.restaurant.stylesheet.twitter, "target": "_blank", "icon": "fa-brands fa-x-twitter", "ariaLabel": "Links to Restaurant X (twitter) - Opens in new tab" }
    out
  menuDrawerRestartLabel: (state, getters) ->
    return "Start Over" unless state?.menuDrawerRestartLabel
    state.menuDrawerRestartLabel
  faqMessage: (state, getters) ->
    return "Start Over" unless state?.faqMessage
    state.faqMessage
  couponDrawer: (state, getters) ->    
    return false unless state?.drawers?.coupon
    state.drawers.coupon
  orderDrawer: (state, getters) ->    
    return false unless state?.drawers?.order
    state.drawers.order
  features: (state, getters) ->
    return [] unless state?.features?.list
    state.features.list
  featuresDrawer: (state, getters) ->
    return false unless state?.drawers?.features
    state.drawers.features
  myway: (state, getters) ->
    return [] unless state?.myway?.list
    state.myway.list
  mywayDrawer: (state, getters) ->    
    return false unless state?.drawers?.myway
    state.drawers.myway

  # Display
  styleSheet: (state, getters) ->
    return '' unless state?.restaurant?.stylesheet?.css
    state.restaurant.stylesheet.css
  stylesheet: (state, getters) ->
    return getters.styleSheet    
  wallpaper: (state, getters) ->
    img = state?.restaurant?.stylesheet?.backgroundUrl    
    return '' if !img
    return '' if img.length <= 0
    img = img.replace(/http:\/\//gi, "https://");
    return img if img.includes('http')
    return "#{@baseURL}#{img}" if img.charAt(0) == '/'
    return "#{@baseURL}/#{img}"
  privacyPolicy: (state, getters) ->
    return '' unless state?.restaurant?.privacyPolicy
    state.restaurant.privacyPolicy
  refundPolicy: (state, getters) ->
    return '' unless state?.restaurant?.refundPolicy
    state.restaurant.refundPolicy
  securityStatement: (state, getters) ->
    return '' unless state?.restaurant?.securityStatement
    state.restaurant.securityStatement
  dialogWidth: (state, getters) ->
    return '100%' unless state?.dialogWidth
    state.dialogWidth
  mobile: (state, getters) ->
    return false  unless getters.dialogWidth == '100%'
    true
  pizzaExtras: (state, getters) ->
    return '' unless state?.pizzaExtras
    state.pizzaExtras
  addonExtras: (state, getters) ->
    return '' unless state?.addonExtras
    state.addonExtras
  itemTotal: (state, getters) ->
    return '' unless state?.itemTotal
    state.itemTotal
  pizzaCount: (state, getters) ->
    return '' unless state?.pizzaCount
    state.pizzaCount
  screenWide: (state, getters) ->
    return '' unless state?.screenWidth
    state.screenWidth
  lang: (state, getters) ->
    return getters.destinationLanguage    
  menuOverflowHidden: (state, getters) ->
    return false unless state?.menu
    state.menu.overflowHidden
  tipLevels: (state, getters) ->
    return [] unless state?.tipLevels
    state.tipLevels
  location: (state, getters) ->
    return {} unless state?.location
    state.location
  updateLocation: (state, getters) ->
    return {} unless state?.location
    state.location
  updateDescFlag: (state, getters) ->
    return {} unless state?.descFlag
    state.descFlag
  updateMenuFlag: (state, getters) ->
    return {} unless state?.menuFlag
    state.menuFlag
  expiration: (state, getters) ->    
    return 0 unless state?.stateTime?.expiration
    state.stateTime.expiration
  warning: (state, getters) ->
    return 0 unless state?.stateTime?.warning
    state.stateTime.warning
  takeoutLocations: (state, getters) ->
    return [] unless state?.restaurant?.takeoutLocations
    tmp = []
    for location, locationIndex in state.restaurant.takeoutLocations
      tmp.push location.location
    tmp
  deliveryLocations: (state, getters) ->
    return [] unless state?.restaurant?.deliveryLocations
    tmp = []
    for location, locationIndex in state.restaurant.takeoutLocations
      tmp.push location.location
    tmp
  locations: (state, getters) ->
    return [] unless state?.restaurant?.locations
    tmp = []
    for location, locationIndex in state.restaurant.locations
      tmp.push location
    tmp
  closedLocations: (state, getters) ->    
    return [] unless state?.restaurant?.closedLocations
    tmp = []
    for location, locationIndex in state.restaurant.closedLocations
      tmp.push location
    tmp
  map: (state, getters) ->
    return undefined unless state?.map
    state.map
  error: (state, getters) ->
    return '' unless state?.error
    state.error
  errorTitle: (state, getters) ->
    return '' unless state?.errorTitle
    state.errorTitle
  baseURL: (state, getters) ->
    return '' unless state?.baseURL
    state.baseURL
  updatePath: (state, getters) ->
    return '' unless state?.path
    state.path
  clickFlag: (state, getters) ->
    return '' unless state?.clickFlag
    state.clickFlag
  # Flags
  flags: (state, getters) ->
    flags = []
    if Array.isArray(state.flags) and state.flags.length > 0
      flags = flags.concat(state.flags)
    flags = [new Set(flags)...]
    if getters.subdomain  
      subdomain = getters.subdomain
      # console.log "out flags subdomain", subdomain      
      if (/kiosk/ui).test(subdomain)
        flags.push("kiosk")
      if (/dev/ui).test(subdomain)
        flags.push("dev")       
    flags = [new Set(flags)...]
    # console.log "out flags", flags
    flags
  dev: (state, getters) ->        
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    restaurant = state.restaurant
    return false unless restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^dev$/ui).test(flag)        
    return false
  version: (state, getters) ->        
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    restaurant = state.restaurant
    return false unless restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^version2.0$/ui).test(flag)        
    return false
  kiosk: (state, getters) ->    
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^kiosk$/ui).test(flag)        
    return false
  noQty: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^noQty$/ui).test(flag)
    return false
  startAtMenuDisplay: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^startAtMenuDisplay$/ui).test(flag)
    return false
  autoRestart: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^autoRestart$/ui).test(flag)
    return false
  noLocationHeader: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^noLocationHeader$/ui).test(flag)
    return false  
  noPrivacyPolicy: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^noPrivacyPolicy$/ui).test(flag)
    return false  
  noRefundPolicy: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^noRefundPolicy$/ui).test(flag)
    return false  
  noSecurityStatement: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^noSecurityStatement$/ui).test(flag)
    return false
  noSearch: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^noSearch$/ui).test(flag)
    return false
  showCouponsMobile: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^showCouponsOnMobile$/ui).test(flag)
    return false  
  noMenuBarSingle: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^noMenuBarSingle$/ui).test(flag)
    return false  
  noMenuHeader: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^noMenuHeader$/ui).test(flag)
    return false  
  noMenuFooter: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^noMenuFooter$/ui).test(flag)
    return false  
  locationHeaderShowMenuText: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^locationHeaderShowMenuText$/ui).test(flag)
    return false  
  recommendations: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^recommendations$/ui).test(flag)
    return false
  recommendationsList: (state, getters) ->
    return [] unless state?.recommendations?.list
    state.recommendations.list
  recommendationsDialog: (state, getters) ->
    return [] unless state?.recommendations?.dialog
    state.recommendations.list
  alert: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^alert$/ui).test(flag)
    return false
  alertTakeout: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^alertTakeout$/ui).test(flag)
    return false
  alertDelivery: (state, getters) ->
    flags = []
    if Array.isArray(getters.flags) and getters.flags.length > 0
      flags = flags.concat(getters.flags)
    flags = [new Set(flags)...]
    return false unless state.restaurant
    return false unless Array.isArray(flags)
    for i, flag of flags
      return true if (/^alertDelivery$/ui).test(flag)
    return false
  alertText: (state, getters) ->
    return "" unless state?.location?.optionalText?.alertText
    state?.location?.optionalText?.alertText